import PropTypes from 'prop-types';

export const SELECT_OPTIONS_PROPTYPES = PropTypes.arrayOf(
    PropTypes.shape({
        value: PropTypes.string,
        display: PropTypes.string
    })
);